<template>
  <div :id="post.id">
    <div
      v-if="
        !post.deleted &&
          post.user_id &&
          post.profileImage &&
          !post.event_id &&
          !post.isGroupRequest
      "
    >
      <div
        :class="user.id == post.user_id ? 'ownChat' : 'otherChat'"
        class="totalChatBox"
      >
        <div
          v-if="post.isFirstPostInARowFromUser && user.id != post.user_id"
          class="nameBox"
        >
          <p>{{ post.username }}</p>
        </div>

        <!--div v-if="post.clips > 0" style="padding: 7px"></div-->

        <div
          :class="user.id == post.user_id ? 'postBox-own' : 'postBox'"
          :style="[
            hasEmojis() || hasClips() ? { 'margin-bottom': '20px' } : {},
          ]"
        >
          <div
            :class="
              user.id == post.user_id ? 'card-left-own' : 'card-left-other'
            "
          >
            <div class="picture">
              <!--span
                v-if="
                  post.user_id &&
                    user.id != post.user_id &&
                    post.isLastPostInARowFromUser
                "
                class="pictureName"
                >{{ post.username }}</span
              -->
              <img
                v-if="
                  post.user_id &&
                    user.id != post.user_id &&
                    post.isLastPostInARowFromUser
                "
                :src="post.profileImage"
                style="object-fit: cover"
              />
            </div>
          </div>

          <div :class="user.id == post.user_id ? 'twoBoxes-own' : 'twoBoxes'">
            <!-- column two (main) -->
            <div class="card-middle-other" :style="{ margin: computedMargin }">
              <div
                :class="
                  user.id == post.user_id ? 'mainCard-own' : 'mainCard-other'
                "
              >
                <div class="media-content">
                  <div class="reply" v-if="post.replyUsername">
                    <button
                      v-if="post.replyUsername"
                      class="replyingButton"
                      v-scroll-to="'#' + post.parent_id"
                    >
                      Replying to {{ post.replyUsername }} : <br />
                      {{ post.replyContent }}
                    </button>
                  </div>
                </div>

                <div
                  :class="
                    user.id == post.user_id ? 'postAndPic-own' : 'postAndPic'
                  "
                >
                  <!-- if there's an image -->
                  <div class="card-image" v-if="!post.replyUsername">
                    <!--style="display: inline-block" inside figure-->
                    <figure
                      class="image"
                      v-for="(file, fileIndex) in post.files"
                      :key="fileIndex + 'm'"
                    >
                      <!-- Displays a light box image view when images are clicked -->
                      <img
                        v-if="isImage(file)"
                        :src="file.src"
                        @click="openGallery(fileIndex, post.files)"
                        class="imageImg"
                      />
                    </figure>

                    <figure
                      v-for="(file, fileIndex) in post.files"
                      :key="fileIndex + 'n'"
                    >
                      <div v-if="!isImage(file)" class="fileBox">
                        <!-- If the file is a video -> display video image -->
                        <!--img v-if="isVideo(file)" src="../assets/video.png" /-->
                        <!--img v-else src="../assets/file.png" /-->
                        <a
                          style="color: #0fb9b1; font-weight: bold"
                          :href="file.src"
                          >{{ file.name }}</a
                        >
                      </div>
                    </figure>
                  </div>

                  <!-- post itself -->
                  <div
                    :class="
                      user.id == post.user_id
                        ? 'postItself-own-plain'
                        : 'postItself-other-plain'
                    "
                    v-if="post.content && !post.replyUsername && !post.replies"
                  >
                    <p v-html="renderContent"></p>
                  </div>
                  <a
                    v-if="post.linkPreview"
                    class="linkPreview"
                    :href="post.linkPreview.url"
                  >
                    <LinkPreview :linkPreview="post.linkPreview" />
                  </a>

                  <div
                    :class="
                      user.id == post.user_id
                        ? 'postItself-own-isReply'
                        : 'postItself-other-isReply'
                    "
                    v-if="post.content && post.replyUsername"
                  >
                    <p>{{ post.content }}</p>
                  </div>

                  <div v-if="hasEmojis()" class="emojiOnPost">
                    <div
                      v-for="(reaction, reactionIndex) in post.reactions"
                      :key="reactionIndex + 'o'"
                    >
                      <div
                        v-if="
                          checkDuplicateExists(reaction.unicode, reactionIndex)
                        "
                      >
                        {{ reaction.unicode }}
                      </div>
                    </div>
                    <div
                      class="numberOfReactions"
                      v-if="post.reactions.length > 1"
                    >
                      {{ post.reactions.length }}
                    </div>
                  </div>
                  <div v-if="post.clips > 0" class="clipOnPost">
                    <div style="width: 15px; height: 15px; margin: 2px">
                      <img src="../assets/clipCount.svg" alt="" />
                    </div>
                    <p style="margin: 2px" class="clipNumber">
                      {{ post.clips }}
                    </p>
                  </div>
                </div>

                <div v-if="listReplies == post.id && showRepliesList">
                  <div
                    v-for="(reply, replyIndex) in replies"
                    :key="replyIndex + 'p'"
                  >
                    <div
                      class="flex-container-list-other"
                      v-if="user.id != post.user_id"
                    >
                      <div class="mainCard-listOther">
                        <p>{{ reply.username }} : {{ reply.content }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- column three (icons) -->
            <div class="card-right-other">
              <div
                :class="user.id == post.user_id ? 'flexIcons-own' : 'flexIcons'"
              >
                <div>
                  <!--v-if="
                  user.id != post.user_id || (isAddingReactions && addReaction)
                "-->
                  <!-- adds and unadds a clip -->
                  <button
                    :style="
                      isAddingReactions && addReaction
                        ? { display: 'flex' }
                        : {}
                    "
                    @click="addClip(post)"
                    class="postActions postClip is-success"
                  ></button>
                </div>
                <div>
                  <!-- Reply button -->
                  <button
                    :style="
                      isAddingReactions && addReaction
                        ? { display: 'flex' }
                        : {}
                    "
                    @click="reply(post)"
                    class="postActions postReply is-primary"
                  ></button>
                </div>
                <div>
                  <!-- Emoji Button -->
                  <div
                    v-if="isAddingReactions && addReaction"
                    class="addReactions"
                  >
                    <AddReaction :post="post" :recentPosts="recentPosts" />
                  </div>
                  <button
                    :style="
                      isAddingReactions && addReaction
                        ? { display: 'flex' }
                        : {}
                    "
                    @click="addEmoji()"
                    class="postActions postReact is-success"
                  ></button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      v-else-if="post.deleted && user.id != post.user_id"
      class="flex-container-deleted"
    >
      <div class="card-left-other"></div>

      <div class="mainCard-delete">
        <i class="post-itself">{{ post.username }} deleted this post</i>
      </div>
    </div>

    <div
      v-else-if="post.deleted && user.id == post.user_id"
      class="flex-container-deleted-own"
    >
      <div class="mainCard-delete-own">
        <!--p class="post-itself">{{ post.username }} has deleted this post</p-->
        <i class="post-itself">deleted</i>
      </div>
    </div>

    <div v-else-if="post.isGroupRequest" class="flex-container-joined">
      <GroupRequest :post="post" />
    </div>

    <div
      v-else-if="!post.user_id && !post.event_id && !post.isGroupRequest"
      class="flex-container-joined"
    >
      <div class="mainCard-delete">
        <p class="post-itself">{{ post.content }}</p>
      </div>
    </div>

    <div v-else-if="post.event_id" class="flex-container-joined">
      <div class="mainCard-calendar">
        <p style="white-space: pre-line" class="post-itself">
          {{ post.content }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import AddReaction from "@/components/AddReactions.vue";
import LinkPreview from "@/components/LinkPreview.vue";
import GroupRequest from "@/components/GroupRequest.vue";

//import { getLinkPreview } from "link-preview-js";

export default {
  props: [
    "post",
    "recentPosts",
    "index",
    "replies",
    "listReplies",
    "profileImage",
  ],

  components: {
    AddReaction,
    LinkPreview,
    GroupRequest,
  },

  data: () => ({
    showRepliesList: false,
    isAddingReactions: false,
  }),

  created() {
    if (this.index === this.recentPosts.length - 1) {
      this.$store.commit("messageBoard/setLoadedInit", true);
    }
    /*
    var content = this.post.content.split(" ");
    content.forEach(async (word) => {
      if (
        (word.includes(".ca") || word.includes(".com")) &&
        !word.includes("https://")
      ) {
        word = "https://" + word;
      }
      if (this.validURL(word)) {
        this.linkPreview = await getLinkPreview(word);
        this.linkPreview.id = this.post.id;
      }
    });
    */
  },

  computed: {
    ...mapState("user", ["user"]),
    ...mapState("messageBoard", ["addReaction"]),
    computedMargin: function() {
      return this.post.isLastPostInARowFromUser && this.post.profileImage != ""
        ? " 2px 0 8px 0 !important"
        : "2px 0 1px 0 !important"; //this had 20px between the 2 0s
    },
    renderContent() {
      /*
      var content = this.post.content.split(" ");
      content.forEach(async (word) => {
        if (
          (word.includes(".ca") || word.includes(".com")) &&
          !word.includes("https://")
        ) {
          word = "https://" + word;
        }
        if (this.validURL(word)) {
          this.linkPreview = await getLinkPreview(word);
          this.linkPreview.id = this.post.id;
        }
      });
      console.log(this.linkPreview);
      */
      if (this.post.atRanges) {
        var content = document.createElement("p");
        var lastIndex = 0;
        this.post.atRanges.forEach((range, index) => {
          if (index % 2 == 0) {
            content.innerHTML += this.post.content.substring(lastIndex, range);
            lastIndex = range;
          } else {
            var span = document.createElement("span");
            if (this.post.user_id === this.user.id) {
              span.className = "gradient-own";
            } else {
              span.className = "gradient-other";
            }
            //span.style.webkitBackgroundClip = "text"
            span.innerHTML = this.post.content.substring(lastIndex, range);
            content.appendChild(span);
            lastIndex = range;
          }
        });
        content.innerHTML += this.post.content.substring(lastIndex);
        return content.innerHTML;
      }
      return this.post.content;
    },
  },

  watch: {
    addReaction() {
      if (!this.addReaction) {
        this.isAddingReactions = false;
      }
    },
  },

  methods: {
    ...mapActions("messageBoard", ["setAddReaction"]),
    validURL(str) {
      var pattern = new RegExp(
        "^(https?:\\/\\/)?" + // protocol
        "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
        "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
        "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
        "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
          "(\\#[-a-z\\d_]*)?$",
        "i"
      ); // fragment locator
      return !!pattern.test(str);
    },
    viewReplies(post_id) {
      this.showRepliesList = !this.showRepliesList;
      this.$emit("viewReplies", post_id);
    },
    addClip(post) {
      this.$emit("toggleClip", post);
    },
    addEmoji() {
      this.isAddingReactions = !this.isAddingReactions;
      this.$store.commit("messageBoard/setAddReaction", true);
    },
    onDelete(post_id) {
      this.$emit("onDelete", post_id);
    },
    reply(post) {
      this.$emit("reply", post);
    },
    openGallery(index, files) {
      this.$emit("openGallery", index, files);
    },

    hasEmojis() {
      if (this.post.reactions) {
        return this.post.reactions.length > 0;
      }
      return false;
    },
    hasClips() {
      if (this.post.clips) {
        return this.post.clips.length > 0;
      }
      return false;
    },
    checkDuplicateExists(emoji, index) {
      if (
        this.post.reactions
          .slice(0, index)
          .findIndex((x) => x.unicode == emoji) != -1 ||
        index > 2
      ) {
        return false;
      }
      return true;
    },

    // If the file is an image
    isImage(file) {
      return file.src.includes("png");
    },

    // If the file is a video
    isVideo(file) {
      return file.src.includes("MP4") || file.src.includes("mp4");
    },
  },
};
</script>

<style src="@/styles/components/Post.css"></style>
